module.exports = "/assets/data/a2e4502ab30df855d5cca46c406ce0ca-BS9.data.json";